export type IConvertStringToNumber = (str: string) => number;

export function convertStringToNumber(str: string): number {
  if (typeof str !== 'string') return str;
  const cleanStr = str
    .replace(/\$/g, '')
    .replace(/%/g, '')
    .replace(/\s/g, '');
  return parseFloat(window.DexeroCoreApp.mergeFieldValues(cleanStr));
}
